import { PersonDTO } from "../dto/PersonDTO";
import { Person, PersonFragment } from "../models/Person";
import { personMetaUnmapper } from "./PersonMetaMapper";
import { useUtility } from "@/composables/useUtility";
import { PersonRelationType, PersonWithRelationsDTO } from "@/autogen";

/**
 * Maps PersonDTO to a cleaner, UI friendly model: Person
 * @param dto
 */
export const personMapper = (dto: PersonWithRelationsDTO): Person => {
  return new Person({
    ...dto,
    personId: dto.assignId,
    id: dto.assignId,
    adminHold: dto.allowSignouts === false,
    emergencyContacts: dto.relationsB?.filter(
      (a) => a.relationTypeId == PersonRelationType.EMERGENCY_CONTACT,
    ),
  });
};

/**
 * Person model to PersonDTO partial
 */
export const personUnMapper = (person: Person): Partial<PersonDTO> => {
  const { unMapPseudoBool } = useUtility();

  const dto = {
    id: person.id,
    personId: person.id,
    nameFirst: person.first,
    nameLast: person.last,
    nameMiddleInitial: person.middle || null,
    namePrefix: person.prefix || null,
    nameSuffix: person.suffix || null,
    personType: person.type,
    dob: person.dob?.toISOString(),
    dobVerified: person.dobVerified,
    email: person.email,
    employer: person.employer,
    phonePrimary: "", //person.primaryPhone,
    phonePrimaryType: "", //person.primaryPhoneType,
    phoneAlternate: "", //person.alternatePhone,
    phoneAlternateType: "", //person.alternatePhoneType,
    allowSignouts: person.adminHold ? "N" : "Y", // logic is opposite so handle this way
    gender: person.gender,
    citizenship: person.citizenship,
    ethnicity: person.ethnicity,
    language: person.language,
    student: unMapPseudoBool(person.student),
  };

  Object.assign(dto, personMetaUnmapper(person.meta as any));
  //Object.assign(dto, emergencyContactUnMapper(person.emergencyContacts as any));
  //Object.assign(dto, addressUnMapper(person.address));

  return dto as any;
};

/**
 * PersonFragment model to PersonDTO partial
 */
export const personFragmentUnMapper = (
  person: PersonFragment,
): Partial<PersonDTO> => {
  const { unMapPseudoBool } = useUtility();

  const dto = {
    nameFirst: person.firstName || null,
    nameLast: person.lastName || null,
    personType: person.type,
    dob: person.dob?.toISOString(),
    dobVerified: person.dobVerified,
    email: person.email,
    phonePrimary: person.primaryPhone,
    phonePrimaryType: person.primaryPhoneType,
    organization: person.meta?.organization,
    orgContact: person.meta?.orgContact,
  } as any;

  return dto;
};

/*
  Field Mappings Person -> PersonDTO
  id: personId
  firstName: nameFirst
  lastName: nameLast
  middleName: nameMiddleInitial
  prefix: namePrefix
  suffix: nameSuffix
  type: personType
  adminHold: allowSignouts
  address1: addr1
  address2: addr2
  address3: addr3
*/
